import { wrapper, headingStyles, subHeadingStyles, trademarkStyles } from './NewHeading.styles';

export const NewHeading: React.FC = () => {
  return (
    <div className={wrapper}>
      <h1 className={headingStyles}>
        Explore The World&apos;s AI<sup className={trademarkStyles}>™</sup>
      </h1>
      <h2 className={subHeadingStyles}>Use any open and closed source models and workflows from leading partners and the community.</h2>
    </div>
  );
};
